
<ng-container
    [ngSwitch]="filter?.key"
>
    <agpr-filter-single-text
        *ngSwitchCase="types.singleText"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-single-text>
    <agpr-filter-text
        *ngSwitchCase="types.text"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-text>
    <agpr-filter-autocomplete
        *ngSwitchCase="types.autocomplete"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-autocomplete>
    <agpr-filter-checkboxes
        *ngSwitchCase="types.checkboxes"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-checkboxes>
    <agpr-filter-range
        *ngSwitchCase="types.range"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-range>
    <agpr-filter-duplicates
        *ngSwitchCase="types.duplicates"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-duplicates>
    <agpr-filter-radio
        *ngSwitchCase="types.radio"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-radio>
    <agpr-filter-date-query
        *ngSwitchCase="types.dateQuery"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-date-query>
    <agpr-filter-group
        *ngSwitchCase="types.group"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-group>
    <agpr-custom-filter-wrapper
        *ngSwitchCase="types.custom"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-custom-filter-wrapper>
    <agpr-filter-keyword
        *ngSwitchCase="types.keyword"
        [id]="id"
        [filter]="filter"
        [style]="style"
    ></agpr-filter-keyword>
</ng-container>
